export default __webpack_public_path__ + "static/garden_design15-395017ef6b0b759dabbef1ad7b945158.webp";